import { useState } from "react";
import { Mail, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { subscribeNewsletter } from "@/lib/api";

export default function Newsletter() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email);
      toast.success(t.newsletter.success);
      setDone(true);
      setEmail("");
    } catch {
      toast.error(t.newsletter.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md" data-testid="newsletter">
      <h4 className="font-bold text-lg mb-1 flex items-center gap-2"><Mail size={18} className="text-primary" /> {t.newsletter.title}</h4>
      <p className="text-sm text-slate-400 mb-4">{t.newsletter.subtitle}</p>
      <form onSubmit={submit} className="flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t.newsletter.placeholder}
          dir="ltr"
          className="flex-1 rounded-full bg-[#0d1836] border border-white/10 px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-[color:var(--primary)]"
          data-testid="newsletter-input"
        />
        <button type="submit" disabled={loading || done} className="rounded-full px-5 py-2.5 text-sm font-bold text-[#04120a] disabled:opacity-60 transition-transform hover:scale-105" style={{ background: "var(--primary)" }} data-testid="newsletter-submit">
          {loading ? <Loader2 size={16} className="animate-spin" /> : done ? <Check size={16} /> : t.newsletter.button}
        </button>
      </form>
    </div>
  );
}
